import { app } from '../../../app';
import {Controller} from "./resources.controller";

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('company.resources', {
        url: '/resources',
        component:'companyResources'
    });
}


// WEBPACK FOOTER //
// ./src/portal/states/company/resources/resources.state.js